import coachPortrait1 from "../assets/coach-portrait-1.png";
import coachPortrait3 from "../assets/coach-portrait-3.png";
import gymPortrait from "../assets/gym-portrait.png";
import heroImage from "../assets/hero.JPG";
import customRecipes from "../assets/customRecipes2.png"
import mealPlanning from "../assets/mealPlanning.png";
import supliment from "../assets/supliment.png";
import macro from "../assets/macro.png";
import logo from "../assets/logo.png";
import ebook from "../assets/Ebook.png";
export const brand = {
  name: "Moataz Hafez",
  tagline: "Fitness Coach",
  accent: "#c3f400",
  price: "960 EGP",
  oldPrice: "1,200 EGP",
  productName: "Elite Nutrition Blueprint",
};

export const images = {
  logo:logo,
  hero: heroImage,
  coach: coachPortrait1,
  detail: coachPortrait3,
  gym: gymPortrait,
  customRecipes:customRecipes,
  mealPlanning:mealPlanning,
  supliment:supliment,
  macro:macro,
  ebook: ebook,

};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "Shop", path: "/shop" },
  { label: "eBook", path: "/ebook" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
  { label: "Account", path: "/account" },
];

export const productHighlights = [
  "Digital download",
  "Macro tracking guide",
  "Meal planning systems",
  "Lifetime updates",
];

export const problems = [
  {
    title: "Random Diets",
    text: "Stop jumping between plans that do not match your training, body weight, or schedule.",
  },
  {
    title: "Confusing Macros",
    text: "Learn how to set protein, carbs, and fats with clear formulas instead of guessing.",
  },
  {
    title: "Low Consistency",
    text: "Use practical meals and flexible rules that make nutrition repeatable under real life pressure.",
  },
];

export const inside = [
  {
    title: "Macro Calculation",
    icon: "%",
    text: "Set calories and macros for fat loss, lean gain, and maintenance phases.",
  },
  {
    title: "Meal Frameworks",
    icon: "M",
    text: "Build simple high-protein meals without boring food or complicated prep.",
  },
  {
    title: "Nutrient Timing",
    icon: "T",
    text: "Structure carbs, hydration, and pre/post-workout meals around performance.",
  },
  {
    title: "Supplement Clarity",
    icon: "S",
    text: "Know what actually helps and what can stay off your shopping list.",
  },
];

export const benefits = [
  {
    title: "Lose Fat Without Panic",
    text: "Use steady adjustments instead of aggressive crashes that ruin training.",
  },
  {
    title: "Build Lean Muscle",
    text: "Match food intake with progressive training and recovery demands.",
  },
  {
    title: "Eat With Structure",
    text: "Plan meals, portions, and substitutions without losing flexibility.",
  },
  {
    title: "Track Like an Athlete",
    text: "Understand the numbers that matter and ignore the noise.",
  },
];

export const chapters = [
  "Nutrition fundamentals and calorie targets",
  "Protein, carbs, fats, and food quality",
  "Fat-loss phases and diet breaks",
  "Lean gaining and performance fueling",
  "Meal prep, shopping lists, and substitutions",
  "Supplements, hydration, and adherence",
];

export const testimonials = [
  {
    name: "Ahmed R.",
    role: "12-week cut",
    quote:
      "The macro setup finally made sense. I kept strength high while dropping weight consistently.",
  },
  {
    name: "Sarah J.",
    role: "Lifestyle transformation",
    quote:
      "Simple, direct, and realistic. The meal structure helped me stay consistent for the first time.",
  },
  {
    name: "Youssef M.",
    role: "Lean bulk",
    quote:
      "I stopped overeating randomly and started gaining with control. The guide is very practical.",
  },
];

export const coachStats = [
  { value: "620K+", label: "Followers" },
  { value: "15K+", label: "Transformations" },
  { value: "10+", label: "Years coaching" },
];
